require('../currentUser');
require('../../appMetaService');

angular.module('app.currentUser.subscriptionStatus.subscriptionStatusController', [
  'app.currentUser',
  'app.appMetaService'
])
  .controller('app.currentUser.subscriptionStatus.subscriptionStatusController', [
    '$scope', 'currentUser', 'serverTime', 'appMetaService',
    function ($scope, currentUser, serverTime, appMetaService) {
      "use strict";

      $scope.current_user = currentUser;
      $scope.hideProgress = $scope.hideProgress || false;
      $scope.hideIfNotExists = $scope.hideIfNotExists || false;
      $scope.activeStatus = null;
      $scope.metaService = appMetaService;
      $scope.subscription = $scope.subscription;

      let getSubscription = function () {
        let subscription = $scope.subscription;

        processSubscription(subscription);

        return subscription;
      };

      let init = function () {
        getSubscription();
      };

      let processSubscription = (subscription) => {
        if (subscription) {
          let period_start = moment(subscription.current_period_started_at);
          let period_end = moment(subscription.current_period_end_date);
          let period_start_unix = period_start.unix();
          let period_end_unix = period_end.unix();
          let period_length = period_end_unix - period_start_unix;
          let current_used_time = serverTime.unix - period_start_unix;
          let remaining_time = period_length - current_used_time;
          let expires_at = moment(subscription.expires_at);
          let auto_resumes = moment(subscription.pause_auto_resumes);
          let activates_at = moment(subscription.activated_at);

          let displayName = "";
          if (subscription.plan) {
            displayName = subscription.plan.name;
          };

          if (subscription.teams && subscription.teams.length > 0) {
            let teamNameArray = subscription.teams.map(t => t.TeamName);
            let subTeams = teamNameArray.join(", ");
            displayName += " " + subTeams;
          }

          $scope.subscriptionState = currentUser.subscriptionStatus(subscription);
          $scope.remaining_percent = Math.floor((remaining_time / period_length) * 100);
          switch ($scope.subscriptionState) {
            case 'active':
              let paused = subscription.paused === true;
              if (subscription.pause_scheduled) {
                $scope.expiry_message = 'Your ' + displayName + ' subscription will pause '
                  + period_end.format('M/D/YYYY') + ' by ' + period_end.format('h:mm a');
              } else if (subscription.is_future) {
                $scope.expiry_message = 'Your ' + displayName + ' subscription will start '
                  + activates_at.format('M/D/YYYY');
              }
              else if (subscription.plan.is_renewable) {
                if (paused) {
                  $scope.expiry_message = 'Your ' + displayName + ' subscription will renew '
                    + auto_resumes.format('M/D/YYYY');
                } else {
                  $scope.expiry_message = 'Your ' + displayName + ' subscription will renew '
                    + period_end.format('M/D/YYYY') + ' before ' + period_end.format('h:mm a');
                }
                $scope.activeStatus = paused ? 'Paused' : 'Auto-renew Active';
              } else {
                $scope.expiry_message = 'Your ' + displayName + ' subscription will end '
                  + period_end.format('M/D/YYYY') + ' by ' + period_end.format('h:mm a');
                $scope.activeStatus = paused ? 'Paused' : 'Active';
              }
              $scope.remaining_class = paused ? 'warning' : 'success';
              break;
            case 'canceled':
              if (subscription.plan.is_renewable) {
                $scope.expiry_message = 'Your auto renew policy has been canceled but your ' +
                  displayName + ' subscription will not expire until ' + period_end.format('M/D/YYYY') +
                  ' by ' + period_end.format('h:mm a') +
                  '. Re-activate your auto renew policy to extend your ' + appMetaService.longName + ' subscription';
                $scope.activeStatus = 'Auto-renew Inactive';
              } else {
                $scope.expiry_message = '';
                $scope.activeStatus = 'Subscription Inactive';
              }
              $scope.remaining_class = 'danger';
              break;
            case 'expired':
              $scope.expiry_message = 'Your ' + displayName + ' expired on '
                + expires_at.format('M/D/YYYY');

              $scope.remaining_class = 'danger';
              $scope.remaining_percent = 0;
              break;
            case 'billing_error':
              $scope.price_message = subscription.plan.currency_symbol + subscription.plan.unit_price;
              $scope.remaining_class = 'danger';
              $scope.remaining_percent = 0;
              break;
            case 'paused':
              $scope.expiry_message = 'Your paused ' + displayName + ' subscription will resume on '
                + auto_resumes.format('M/D/YYYY');
              break;
            case 'future':
              $scope.expiry_message = 'Your ' + displayName + ' subscription will start on '
                + activates_at.format('M/D/YYYY');
              break;
            default:
              $scope.remaining_class = 'info';
              break;
          }
        } else {
          $scope.remaining_percent = 0;
          $scope.remaining_class = 'info';
          $scope.expiry_message = null;
        }
      };

      $scope.isActive = function () {
        let subscription = getSubscription();

        if (subscription) {
          switch (subscription.state) {
            case 'active':
            case 'canceled':
              return true;
          }
        }
        return false;
      };

      $scope.hasSubscription = function () {
        return currentUser.subscriptions.recurly.length > 0;
      };

      init();

      $scope.$on('current_plan_retrieved', function () {
        init();
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentUser/subscriptionStatus/subscriptionStatusController.js